export default {
  route: {
    dashboard: '监控首页',
    documentation: '文档',
    guide: '引导页',
    permission: '权限测试页',
    rolePermission: '角色权限',
    pagePermission: '页面权限',
    directivePermission: '指令权限',
    icons: '图标',
    components: '组件',
    tinymce: '富文本编辑器',
    markdown: 'Markdown',
    jsonEditor: 'JSON 编辑器',
    dndList: '列表拖拽',
    splitPane: 'Splitpane',
    avatarUpload: '头像上传',
    dropzone: 'Dropzone',
    sticky: 'Sticky',
    countTo: 'Count To',
    componentMixin: '小组件',
    backToTop: '返回顶部',
    dragDialog: '拖拽 Dialog',
    dragSelect: '拖拽 Select',
    dragKanban: '可拖拽看板',
    charts: '图表',
    keyboardChart: '键盘图表',
    lineChart: '折线图',
    mixChart: '混合图表',
    example: '综合实例',
    nested: '路由嵌套',
    menu1: '菜单1',
    'menu1-1': '菜单 1-1',
    'menu1-2': '菜单 1-2',
    'menu1-2-1': '菜单 1-2-1',
    'menu1-2-2': '菜单 1-2-2',
    'menu1-3': '菜单 1-3',
    menu2: '菜单 2',
    Table: 'Table',
    dynamicTable: '动态 Table',
    dragTable: '拖拽 Table',
    inlineEditTable: 'Table 内编辑',
    complexTable: '综合 Table',
    tab: 'Tab',
    form: '表单',
    createArticle: '创建文章',
    editArticle: '编辑文章',
    articleList: '文章列表',
    errorPages: '错误页面',
    page401: '401',
    page404: '404',
    errorLog: '错误日志',
    excel: 'Excel',
    exportExcel: '导出 Excel',
    selectExcel: '导出 已选择项',
    mergeHeader: '导出 多级表头',
    uploadExcel: '上传 Excel',
    zip: 'Zip',
    pdf: 'PDF',
    exportZip: 'Export Zip',
    theme: '换肤',
    clipboardDemo: 'Clipboard',
    i18n: '国际化',
    externalLink: '外链',
    profile: '个人中心'
  },
  common:{
    SSTCD:'测站名称或编码',
    DEPTID:'所属单位',
    VALLEY:'所属流域',
    STTP:'测站类型'
  },
  users: {
    dynamicTips1: '固定表头, 按照表头顺序排序',
    dynamicTips2: '不固定表头, 按照点击顺序排序',
    dragTips1: '默认顺序',
    dragTips2: '拖拽后顺序',
    locality: '管理单位',
    instcd: '管理单位',
    username: '用户姓名',
    userid: '用户名',
    pwd: '用户密码',
    pwds: '确认密码',
    groupname: '分组名称',
    usertype: '用户类型',
    useraccount: '用户账号',
    importance: '重要性', // 0
    type: '类型', // 0
    remark: '点评', // 0
    search: '查询',
    add: '添加', // 0
    export: '下载',
    import: '上传',
    memo: '备注',
    id: '序号',
    lastuser: '上传人',
    crtm: '创建时间',
    uptn: '修改时间',
    readings: '阅读数', // 0
    actions: '操作',
    edit: '编辑', // 0
    publish: '发布', // 0
    draft: '草稿', // 0
    delete: '删除', // 0
    cancel: '取 消', // 0
    confirm: '确 定'// 0
  },
  appuser: {
    id: '序号',
    USERID: '用户名',
    dept: '所属单位',
    examine: '审批',
    resetpwd: '重置密码',
    setenable: '启用',
    setdisenable: '停用',
    strprpassign: '测站分配',
    USERNM: '用户姓名',
    NAME: '用户名',
    EXAMINESTATE: '审批状态',
    ENABLEDSTA: '启用状态',
    SYSADMIN: '是否管理员',
    MOBILETEL: '联系方式',
    DEPTID: '所属单位',
    LEADERNAME: '直属上级',
    LEADERTEL: '上级联系方式',
    APPLYTM: '申请时间', // 无
    EXAMINEUSER: '审批人', // 无
    EXAMINETM: '审批时间', // 无
    search: '查询',
    add: '添加',
    edit: '编辑',
    delete: '删除',
    cancel: '取 消',
    confirm: '确 定'
  },
  webuser: {
    id: '序号',
    USERID: '用户名',
    dept: '单位',
    examine: '审批',
    resetpwd: '重置密码',
    setenable: '启用',
    setdisenable: '停用',
    strprpassign: '测站分配',
    USERNM: '用户姓名',
    LIMITTYPE: '权限类型',
    DEPTID: '所属单位',
    SURYID:'勘测队',
    DUTY: '职务',
    // NAME: '登录账号',
    // EXAMINESTATE: '审批状态',
    ENABLEDSTA: '启用状态',
    SYSADMIN: '是否管理员',
    MOBILETEL: '联系方式',
    REMARK: '备注',
    // DEPTID: '所在单位',
    // LEADERNAME: '直属上级',
    // LEADERTEL: '上级联系方式',
    // APPLYTM: '申请时间', // 无
    // EXAMINEUSER: '审批人', // 无
    // EXAMINETM: '审批时间', // 无
    search: '查询',
    add: '添加',
    actions: '操作',
    edit: '编辑',
    delete: '删除',
    cancel: '取 消',
    confirm: '确 定'
  },
  auditing: {
    search: '查询',
    add: '添加',
    export: '下载',
    import: '上传',
    memo: '备注',
    actions: '操作',
    edit: '编辑',
    publish: '发布',
    draft: '草稿',
    delete: '删除',
    cancel: '取 消',
    confirm: '确 定'
  },
  auditingmon: {
    search: '查询',
    add: '添加',
    export: '下载',
    import: '上传',
    memo: '备注',
    STCDNM: '测站名称或编码',
    STCD: '测站编码',
    STNM: '测站名称',
    DEPTNM: '所属单位',
    SLTM: '上报时间',
    CHANNEL: '上报信道',
    RESTATE: '上报状态', // 无
    DATASTATE: '数据状态', 
    DATATM: '数据时间', 
    SLCON: '报文',
    REVIEWUSER: '审核人',
    REVIEWTIME: '审核时间',
    USERNM: '上报人',
    USERID: '上报人',
    MOBILETEL: '上报人联系方式',
    LEADERNAME: '上级领导',
    LEADERTEL: '上级领导联系方式',
    MODIFYTIME: '修改时间',
    MODIFYUSER: '修改人',
    TEMPID: '数据类型', // '模板名称',
    actions: '操作',
    edit: '编辑',
    publish: '发布',
    draft: '草稿',
    delete: '删除',
    cancel: '取 消',
    confirm: '确 定'
  },
  auditinginter: {
    id: '序号',
    setall: '设置全部',
    setexceed: '设置拦截',
    resetpwd: '重置密码',
    STCD: '测站编码', // 无
    STNM: '测站名称', // 无
    SETTM: '设置时间', // 无
    HEIGHTALARM: '最大值水位(m)', // 无
    HEIGHTXX: '最小值水位(m)', // 无
    HEIGHTSURE: '最大流量(m³/s)', // 无
    HEIGHTHISTORY: '最小流量(m³/s)', // 无

    HEIGHTALARMD: '最大值水位', // 无
    HEIGHTXXD: '最小值水位', // 无
    HEIGHTSURED: '最大流量', // 无
    HEIGHTHISTORYD: '最小流量', // 无

    search: '查询',
    add: '添加',
    actions: '操作',
    edit: '编辑',
    delete: '删除',
    cancel: '取 消',
    confirm: '确 定'
  },
  auditingcheck: {
    search: '查询',
    add: '添加',
    export: '下载',
    import: '上传',
    id: '序号',
    DEPTID: '单位ID',
    DEPTCODE: '单位编码',
    DEPTNM: '单位名称',
    DEPTPER: '联系人',
    DEPTTEL: '联系方式',
    DEPTADR: '地址',
    REMARK: '备注',

    STCD: '测站编码',
    STNM: '测站名称',
    SLTM: '上报时间',
    DLTM: '数据时间',
    RESTATE: '上报状态', // 无
    DATASTATE: '审核状态', // 无
    CHANNEL: '上报信道',

    SLCON: '报文',
    DYP: '日降雨量',
    SZ: '瞬时水位',
    WTH: '天气状况',
    SQ: '瞬时流量',
    WPTN: '水势',
    DAQ: '日均流量',
    QM: '流量测法',
    MXQ: '最大流量',
    MXQTM: '最大流量时间',
    MNQ: '最小流量',
    MNQTM: '最小流量时间',
    TEMPID: '模板名称',
    REVIEWUSER: '审核人',
    REVIEWTIME: '审核时间',
    USERNM: '上报人',
    USERID: '上报人',
    MOBILETEL: '上报人联系方式',
    MODIFYTIME: '修改时间',
    MODIFYUSER: '修改人',
    actions: '操作',
    edit: '编辑',
    check: '审核',
    publish: '发布',
    draft: '草稿',
    delete: '删除',
    cancel: '取 消',
    confirm: '确 定'
  },
  unit: {
    search: '查询',
    add: '添加',
    DEPTCODEID: '单位名称或编码',
    DEPTPEREL: '联系人或联系方式',
    export: '下载',
    import: '上传',
    id: '序号',
    DEPTID: '单位ID',
    DEPTCODE: '单位编码',
    DEPTNM: '单位名称',
    DEPTTYPE: '单位类型',
    DEPTPER: '联系人',
    DEPTTEL: '联系方式',
    DEPTADR: '地址',
    REMARK: '备注',
    SORT:'排序',
    actions: '操作',
    edit: '编辑',
    publish: '发布',
    draft: '草稿',
    delete: '删除',
    cancel: '取 消',
    confirm: '确 定'
  },
  survey: {
    search: '查询',
    add: '添加',
    DEPTCODEID: '勘测队名称',
    export: '下载',
    import: '上传',
    id: '序号',
    SURYID: '勘测队ID',
    SURYNM: '勘测队名称',
    SURYADR: '地址',
    REMARK: '备注',
    DEPTID: '所属单位',
    SORT:'排序',
    actions: '操作',
    edit: '编辑',
    publish: '发布',
    draft: '草稿',
    delete: '删除',
    cancel: '取 消',
    confirm: '确 定'
  },
  template: {
    search: '查询',
    add: '添加',
    export: '下载',
    import: '上传',
    setenable: '启用',
    setdisenable: '停用',
    id: '序号',
    TEMPNAME: '模板名称',
    TYPE: '模板类型',
    ENABLEDSTA: '启用状态',
    LASTTM: '最后修改时间', // 无
    TIMELEN: '上报时段长',
    ICON: '图标',
    SORT: '排序',
    REMARK: '备注',
    FLOODSET: '报汛项配置', // 无
    SET: '配置', // 无
    actions: '操作',
    edit: '编辑',
    publish: '发布',
    draft: '草稿',
    delete: '删除',
    cancel: '取 消',
    confirm: '确 定'
  },
  files: {
    search: '查询',
    add: '添加',
    export: '下载',
    import: '上传',
    setenable: '启用',
    setdisenable: '停用',
    id: '序号',
    NAME: '简报名称',
    TYPE: '简报类型',
    TM: '统计时间', 
    USERID: '上传人',
    CREATETM: '上传时间',
    actions: '操作',
    edit: '编辑',
    publish: '发布',
    draft: '草稿',
    delete: '删除',
    cancel: '取 消',
    confirm: '确 定'
  },
  mainp: {
    search: '查询',
    add: '添加',
    export: '下载',
    import: '上传',
    setenable: '启用',
    setdisenable: '停用',
    id: '序号',
    FUNCODE: '应用CODE',
    FUNNAMEO: '功能名称',
    FUNNAME: '应用名称',
    ORDERBY: '显示排序', 
    SHOWTYPE: '图标类型',
    USERTYPE: '用户类型',
    ICON: '小图标', //F
    FONTCOLOR: '小图标颜色',//F
    COLOR: '背景颜色',//F
    BACKGROUND: '背景图片',//F
    ICON_A: '小图片', //F B 
    ICON_B: '选中小图片', //B
    ACTCOLOR: '选中字体颜色',//已触发字体及背景颜色 B
    ICONSIZE: '单行宫格数量',//F
    actions: '操作',
    edit: '编辑',
    publish: '发布',
    draft: '草稿',
    delete: '删除',
    cancel: '取 消',
    confirm: '确 定',
    save: '保存'
  },
  dataf: {
    search: '查询',
    add: '添加',
    export: '下载',
    import: '上传',
    setenable: '启用',
    setdisenable: '停用',
    id: '序号',
    FUNCODE: '应用CODE',
    FUNNAMEO: '功能名称',
    FUNNAME: '应用名称',
    ORDERBY: '显示排序', 
    SHOWTYPE: '图标类型',
    USERTYPE: '用户类型',
    ICON: '小图标', //F
    FONTCOLOR: '小图标颜色',//F
    COLOR: '背景颜色',//F
    BACKGROUND: '背景图片',//F
    ICON_A: '小图片', //F B 
    ICON_B: '选中小图片', //B
    //ACTCOLOR: '已触发字体颜色',//已触发字体及背景颜色 B
    actions: '操作',
    edit: '编辑',
    publish: '发布',
    draft: '草稿',
    delete: '删除',
    cancel: '取 消',
    confirm: '确 定'
  },
  funp: {
    search: '查询',
    add: '添加',
    export: '下载',
    import: '上传',
    setenable: '启用',
    setdisenable: '停用',
    id: '序号',
    FUNCODE: '应用CODE',
    FUNNAME: '应用名称',
    PARAMERTES: '应用参数', 
    URL: '应用跳转地址',
    TYPE: '应用打开类型',
    TITLE: '应用页面显示配置',
    actions: '操作',
    edit: '编辑',
    publish: '发布',
    draft: '草稿',
    delete: '删除',
    cancel: '取 消',
    confirm: '确 定'
  },
  service: {
    search: '查询',
    add: '添加',
    export: '下载',
    import: '上传',
    setenable: '启动',
    setdisenable: '停止',
    id: '序号',
    RECVSRVID: '服务标识',
    SENDMSGSTA: '短信发送标识',
    RECVSRVNM: '服务名称',
    SRVREMARK: '服务描述',
    COMUTYPE: '通讯类型',
    PRTCID: '协议类型',
    SRVCOLOR: '服务颜色',
    COMUPARA: '通讯参数',
    SRVSTA: '状态',
    REMARK: '备注', // 无
    actions: '操作',
    edit: '编辑',
    publish: '发布',
    draft: '草稿',
    delete: '删除',
    cancel: '取 消',
    confirm: '确 定'
  },
  system: {
    search: '查询',
    add: '添加',
    export: '下载',
    import: '上传',
    memo: '备注',
    id: '序号',
    actions: '操作',
    edit: '编辑',
    publish: '发布',
    draft: '草稿',
    delete: '删除',
    cancel: '取 消',
    confirm: '确 定'
  },
  flood: {
    id: '序号',
    USERID: '用户ID',
    dept: '单位',
    examine: '审批',
    resetpwd: '重置密码',
    setenable: '启用',
    setdisenable: '停用',
    STCD: '测站编码',
    STNM: '测站名称',
    DEPTID: '所属单位',
    STADR: '地址',
    STTP: '测站类型',
    FRGRD: '报汛等级',
    RECVSRVID: '接收服务',
    ENABLEDSTA: '启用状态',
    BSNM: '流域',
    HNNM: '水系',
    RVNM: '河流',
    // RTUCODE: 'RTU编号',
    RTUTYPE: 'RTU类型',
    LGTD: '经度',
    LTTD: '纬度',
    NOTE: '备注',
    search: '查询',
    add: '添加',
    actions: '操作',
    edit: '编辑',
    delete: '删除',
    cancel: '取 消',
    confirm: '确 定'
  },
  floodexc: {
    id: '序号',
    setall: '设置全部',
    setexceed: '设置参数',
    resetpwd: '重置密码',
    STCD: '测站编码',
    STNM: '测站名称',
    SETTM: '设置时间', // 无
    CREATETM:'创建时间',
    MODITM:'修改时间',
    USERNM:'设置人',
    GUARDZ: '超警戒水位(m)',
    LIMITZ: '超汛限水位(m)',
    GUARANTEEZ: '超保证水位(m)',
    HISTORYZ: '超历史水位(m)',
    MAXZU: '最大水位(m)',
    MINZU: '最小水位(m)',
    MAXQU: '最大流量(m³/s)',
    MINQU: '最小流量(m³/s)',
    MAXZ: '最大水位',
    MINZ: '最小水位',
    MAXQ: '最大流量',
    MINQ: '最小流量',
    HEIGHTALARMD: '超警戒水位', // 无
    HEIGHTXXD: '超汛限水位', // 无
    HEIGHTSURED: '超保证水位', // 无
    HEIGHTHISTORYD: '超历史水位', // 无

    GUARDQU:'警戒流量(m³/s)',
    GUARANTEEQU:'保证流量(m³/s)',
    LIMITWATERU:'汛限水位蓄水量(百万m³)',
    MAXWATERU:'最高水位蓄水量(百万m³)',

    GUARDQ:'警戒流量',
    GUARANTEEQ:'保证流量',
    LIMITWATER:'汛限水位蓄水量',
    MAXWATER:'最高水位蓄水量',

    search: '查询',
    add: '添加',
    actions: '操作',
    edit: '编辑',
    delete: '删除',
    cancel: '取 消',
    confirm: '确 定'
  },
  folldpacket: {
    search: '查询',
    add: '添加',
    export: '下载',
    import: '上传',
    setenable: '启用',
    setdisenable: '停用',
    id: '序号',
    TEMPNAME: '模板名称',
    TYPE: '模板类型',
    ENABLEDSTA: '启用状态',
    LASTTM: '最后修改时间', // 无
    REMARK: '备注',
    FLOODSET: '报汛项配置', // 无
    SET: '配置', // 无

    STNM: '测站名称',
    STCD: '测站编码',
    DATATM: '数据时间',
    DYP: '日降雨量',
    RP: 'P12降雨量',
    SZ: '瞬时水位',
    QM: '流量测法',
    SQ: '瞬时流量',
    MAXQ: '最大流量',
    MINQ: '最小流量',
    DAQ: '日均流量',
    MAXQTM: '最大流量时间',
    MINQTM: '最小流量时间',
    MAXT: '最高气温',
    MINT: '最低气温',
    DAT: '日均气温',
    WTH: '天气状况',
    WPTN: '水势',

    actions: '操作',
    edit: '编辑',
    publish: '发布',
    draft: '草稿',
    delete: '删除',
    cancel: '取 消',
    confirm: '确 定'
  },
  packethistory: {
    search: '查询',
    add: '添加',
    editmessage: '人工报汛',
    TYPE: '上报类型',
    REVIEWSTATE: '审核状态', // 无
    STTP: '测站类型',
    export: '导出',
    import: '上传',
    id: '序号',
    DEPTID: '单位ID',
    DEPTCODE: '单位编码',
    DEPTNM: '单位名称',
    DEPTPER: '联系人',
    DEPTTEL: '联系方式',
    DEPTADR: '地址',
    REMARK: '备注',

    STCD: '测站编码',
    STNM: '测站名称',
    SLTM: '上报时间',
    RESTATE: '上报状态', // 无
    DATASTATE: '数据状态', // 无
    HEADOFF:'拦截状态',
    CHANNEL: '上报信道',

    SLCON: '报文',
    DYP: '日降雨量',
    SZ: '瞬时水位',
    WTH: '天气状况',
    SQ: '瞬时流量',
    WPTN: '水势',
    DAQ: '日均流量',
    QM: '流量测法',
    MXQ: '最大流量',
    MXQTM: '最大流量时间',
    MNQ: '最小流量',
    MNQTM: '最小流量时间',

    REVIEWUSER: '审核人',
    REVIEWTIME: '审核时间',
    USERNM: '上报人',
    USERID: '上报人',
    MOBILETEL: '上报人联系方式',
    MODIFYTIME: '修改时间',
    MODIFYUSER: '修改人',
    actions: '操作',
    edit: '编辑',
    check: '审核',
    publish: '发布',
    draft: '草稿',
    delete: '删除',
    cancel: '取 消',
    confirm: '确 定'
  },
  // packet: {
  //   id: '序号',
  //   USERID: '用户ID',
  //   dept: '单位',
  //   examine: '审批',
  //   flood: '人工报汛',
  //   export: '导出',
  //   setenable: '启用',
  //   setdisenable: '停用',
  //   STTP: '测站类型',
  //   TEMPLATETYPE: '上报类型',
  //   REVIEWSTATE: '审核状态',

  //   STCD: '测站编号',
  //   STNM: '测站名称',
  //   SLTM: '上报时间',
  //   CHANNEL: '上报信道',
  //   WARNING: '数据状态',
  //   SLCON: '报文',
  //   DYP: '日降雨量',
  //   SZ: '瞬时水位',
  //   WTH: '天气状况',
  //   SQ: '瞬时流量',
  //   WPTN: '水势',
  //   DAQ: '日均流量',
  //   QM: '流量测法',
  //   MXQ: '最大流量',
  //   MXQTM: '最大流量时间',
  //   MNQ: '最小流量',
  //   MNQTM: '最小流量时间',
  //   // MAXT: '最高气温',
  //   // MINT: '最低气温',
  //   // DAT: '日均气温',

  //   USERNM: '用户名',
  //   LIMITTYPE: '权限类型',
  //   DEPTID: '所属单位',
  //   DUTY: '职务',
  //   // NAME: '登录账号',
  //   // EXAMINESTATE: '审批状态',
  //   ENABLEDSTA: '启用状态',
  //   MOBILETEL: '联系方式',
  //   REMARK: '备注',
  //   // DEPTID: '所在单位',
  //   // LEADERNAME: '直属上级',
  //   // LEADERTEL: '上级联系方式',
  //   // APPLYTM: '申请时间', // 无
  //   // EXAMINEUSER: '审批人', // 无
  //   // EXAMINETM: '审批时间', // 无
  //   search: '查询',
  //   add: '添加',
  //   actions: '操作',
  //   edit: '编辑',
  //   delete: '删除',
  //   cancel: '取 消',
  //   confirm: '确 定'
  // },
  navbar: {
    dashboard: '监控首页',
    github: '项目地址',
    logOut: '退出登录',
    profile: '个人中心',
    theme: '换肤',
    size: '布局大小'
  },
  login: {
    title: '系统登录',
    logIn: '登录',
    username: '账号',
    password: '密码',
    any: '随便填',
    thirdparty: '第三方登录',
    thirdpartyTips: '本地不能模拟，请结合自己业务进行模拟！！！'
  },
  documentation: {
    documentation: '文档',
    github: 'Github 地址'
  },
  permission: {
    addRole: '新增角色',
    editPermission: '编辑权限',
    roles: '你的权限',
    switchRoles: '切换权限',
    tips: '在某些情况下，不适合使用 v-permission。例如：Element-UI 的 el-tab 或 el-table-column 以及其它动态渲染 dom 的场景。你只能通过手动设置 v-if 来实现。',
    delete: '删除',
    confirm: '确定',
    cancel: '取消'
  },
  guide: {
    description: '引导页对于一些第一次进入项目的人很有用，你可以简单介绍下项目的功能。本 Demo 是基于',
    button: '打开引导'
  },
  components: {
    documentation: '文档',
    tinymceTips: '富文本是管理后台一个核心的功能，但同时又是一个有很多坑的地方。在选择富文本的过程中我也走了不少的弯路，市面上常见的富文本都基本用过了，最终权衡了一下选择了Tinymce。更详细的富文本比较和介绍见',
    dropzoneTips: '由于我司业务有特殊需求，而且要传七牛 所以没用第三方，选择了自己封装。代码非常的简单，具体代码你可以在这里看到 @/components/Dropzone',
    stickyTips: '当页面滚动到预设的位置会吸附在顶部',
    backToTopTips1: '页面滚动到指定位置会在右下角出现返回顶部按钮',
    backToTopTips2: '可自定义按钮的样式、show/hide、出现的高度、返回的位置 如需文字提示，可在外部使用Element的el-tooltip元素',
    imageUploadTips: '由于我在使用时它只有vue@1版本，而且和mockjs不兼容，所以自己改造了一下，如果大家要使用的话，优先还是使用官方版本。'
  },
  table: {
    dynamicTips1: '固定表头, 按照表头顺序排序',
    dynamicTips2: '不固定表头, 按照点击顺序排序',
    dragTips1: '默认顺序',
    dragTips2: '拖拽后顺序',
    title: '标题',
    importance: '重要性',
    type: '类型',
    remark: '点评',
    search: '查询',
    add: '添加',
    export: '导出',
    reviewer: '审核人',
    id: '序号',
    date: '时间',
    author: '作者',
    readings: '阅读数',
    status: '状态',
    actions: '操作',
    edit: '编辑',
    publish: '发布',
    draft: '草稿',
    delete: '删除',
    cancel: '取 消',
    confirm: '确 定'
  },
  example: {
    warning: '创建和编辑页面是不能被 keep-alive 缓存的，因为keep-alive 的 include 目前不支持根据路由来缓存，所以目前都是基于 component name 来进行缓存的。如果你想类似的实现缓存效果，可以使用 localStorage 等浏览器缓存方案。或者不要使用 keep-alive 的 include，直接缓存所有页面。详情见'
  },
  errorLog: {
    tips: '请点击右上角bug小图标',
    description: '现在的管理后台基本都是spa的形式了，它增强了用户体验，但同时也会增加页面出问题的可能性，可能一个小小的疏忽就导致整个页面的死锁。好在 Vue 官网提供了一个方法来捕获处理异常，你可以在其中进行错误处理或者异常上报。',
    documentation: '文档介绍'
  },
  excel: {
    export: '导出',
    selectedExport: '导出已选择项',
    placeholder: '请输入文件名(默认excel-list)'
  },
  zip: {
    export: '导出',
    placeholder: '请输入文件名(默认file)'
  },
  pdf: {
    tips: '这里使用   window.print() 来实现下载pdf的功能'
  },
  theme: {
    change: '换肤',
    documentation: '换肤文档',
    tips: 'Tips: 它区别于 navbar 上的 theme-pick, 是两种不同的换肤方法，各自有不同的应用场景，具体请参考文档。'
  },
  tagsView: {
    refresh: '刷新',
    close: '关闭',
    closeOthers: '关闭其它',
    closeAll: '关闭所有'
  },
  settings: {
    title: '系统布局配置',
    theme: '主题色',
    tagsView: '开启 Tags-View',
    fixedHeader: '固定 Header',
    sidebarLogo: '侧边栏 Logo'
  },
  log:{
    search:'查询',
    id:'序号',
    SYSLOGID:'日志ID',
    SLTYPE:'日志类型',
    SLTM:'日志时间',
    SLCON:'日志内容',
    USERID:'操作人',
    STCD:'站点编码',
    USERNM:'操作人姓名',
    //SLTM:'排序规则'
  }
  ,situation:{
    SSTCD:'测站编码或名称',
    STCD:'测站编码',
    dept:'所属单位',
    STNM:'站名',
    TDAVQ:'旬均流量',
    MAVQ:'月均流量',
    MMXQ:'月最大',
    HTQTM:'出现时间',
    TDP:'旬降水',
    MHP:'月降水',
    TDAVT:'旬均气温',
    MAVT:'月均气温',

    AVGQ:'平均流量',
    MAXQ:'最大流量',
    MAXTM:'出现时间',
    SUMDYP:'降水',
    AVGATMP:'平均气温',

    ADDRESS:'地区(地、州)',
    HVNM:'河名',
    WSTNM:'水文站名',
    EHQ:'八时流量',
    GUARDQ:'警戒流量',
    GUARANTEEQ:'保证流量',
    STATE:'说明',

    RSTNM:'水库名称',
    RADDRESS:'水库地址',
    TM:'时间',
    HOUR:'时',
    DAY:'日',
    WPTN:'水势',
    WTH:'天气',
    Z:'蓄水位',
    W:'蓄水量',
    INQ:'入库流量',
    OTQ:'出库流量',
    LIMITZ:'汛限水位',
    LIMITW:'汛限蓄水量',
    MXSAFEW:'最高安全蓄水量',
    //STATE:'说明',
    strprpassign:'测站选择'
  }
  ,statistic:{
    DBL:'到报率',
    CHIBL:'迟报率',
    LBL:'漏报率',
    CUOBL:'错报率'
  }
}
